import * as React from "react";
import styled from "styled-components";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import UserIcon from "./UserIcon";


const navItems = [
    { label: "Activities", to: "/activities" },
    { label: "Artifacts", to: "/artifacts" },
    { label: "Members", to: "/members" },
    // { label: "Team Dynamics", to: "/team_dynamics" },
    // { label: "Settings", to: "/settings" },
];

const NavItem = ({ label, to }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = location.pathname.startsWith(to);
  const handleClick = (e) => {
    e.preventDefault();
    navigate(to);
  };

  return (
    <NavItemWrapper $isActive={isActive} onClick={handleClick}>
      <StyledLink to={to}>{label}</StyledLink>
      {isActive && <ActiveIndicator />}
    </NavItemWrapper>
  );
};

const MyHeader = ({ alertComponent, hideNav = false }) => {
  const { groupName, groupInfo, isView } = useAuth();

  return (
    <Header>
      <HeaderWrapper>
        <CourseInfoWrapper>
          <TopRow>
            <CourseNameGroup>
              <CourseName>
                <StyledLink to={isView ? "/admin/home" : "/student/home"}>
                  {groupInfo.name}
                </StyledLink>
              </CourseName>
              <GroupName>{groupName}</GroupName>
            </CourseNameGroup>
            <UserIcon />
          </TopRow>
          {!hideNav && (
            <NavRow>
              <Nav>
                {navItems.map((item, index) => (
                  <NavItem key={index} label={item.label} to={item.to} />
                ))}
              </Nav>
              {alertComponent && (
                <AlertWrapper>
                  {alertComponent}
                </AlertWrapper>
              )}
            </NavRow>
          )}
        </CourseInfoWrapper>
      </HeaderWrapper>

    </Header>
  );
};

const StyledLink = styled(Link)`
    all: unset;
    cursor: pointer;
`;

const HeaderWrapper = styled.header`
  display: flex;
  width: 100%;
  gap: 20px;
  color: #000;
  justify-content: space-between;
  padding: 20px 28px;
  box-sizing: border-box;

  @media (max-width: 991px) {
    max-width: 100%;
    flex-wrap: wrap;
  }

  @media (max-width: 600px) {
    padding: 12px 16px;
    gap: 10px;
  }
`;

const CourseInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 8px;
  min-width: 0;
`;

const TopRow = styled.div`
  display: flex;
    width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 12px;
  min-width: 0;

  @media (max-width: 600px) {
    margin-bottom: 12px;
  }
`;

const CourseNameGroup = styled.div`
    display: flex;
    //justify-content: space-between;
    align-items: center;
    width: 80%;
    min-width: 0;
    flex: 1;

    @media (max-width: 600px) {
      width: auto;
    }
`;

const CourseName = styled.h1`
    font: 700 30px Inter, sans-serif;
    max-width: 60%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: 0;

    @media (max-width: 600px) {
      font-size: 20px;
      max-width: 55%;
    }
`;

const GroupName = styled.h2`
    max-width: 40%;
    font: 400 18px Inter, sans-serif;
    text-align: left;
    padding-left: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: 0;

    @media (max-width: 600px) {
      font-size: 14px;
      padding-left: 8px;
      max-width: 45%;
    }
`;

const NavRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 20px;
  min-height: 44px;

  @media (max-width: 600px) {
    flex-wrap: wrap;
    gap: 10px;
  }
`;

const Nav = styled.nav`
  display: flex;
  gap: 20px;
  margin-top: 0px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    gap: 14px;
  }
`;

const AlertWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  max-width: 600px;
`;

const NavItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${props => props.$isActive ? "#9333ea" : "#969a97"};
  font-size: 18px;
  font-weight: 700;
  font-family: Inter, sans-serif;
  white-space: nowrap;

  @media (max-width: 600px) {
    font-size: 14px;
  }
`;

const ActiveIndicator = styled.div`
  background-color: #9333ea;
  height: 3px;
  width: 100%;
  margin-top: 8px;
`;
const Header = styled.div`
   width: 100%;
  background-color: #fff;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  z-index: 100; /* Ensure it's above other elements */
  position: sticky;
  top: 0;
`;
export default MyHeader;
